import { useTranslation } from "react-i18next";
import classes from "./styles.module.css";
import ProductsSlider from "../newset/productsSlider/ProductsSlider";
import { FC } from "react";
import { ProductItemType } from "src/types/products/ProductItem";


interface OffersProp {
    data: ProductItemType[]
}

const Offers: FC<OffersProp> = ({ data }) => {
    const { t } = useTranslation(['home']);

    return (
        <section className={classes.offers}>
            <div className="container">
                <div className={classes.sectionShell}>
                    <div className={classes.header}>
                        <h2 className={classes.title}>{t('offers.title')}</h2>
                        <p className={classes.subtitle}>{t('offers.subtitle')}</p>
                    </div>
                    <ProductsSlider data={data} productVariant="home" settings={OFFERS_SETTINGS} />
                </div>
            </div>
        </section>
    )
}

export default Offers;

const OFFERS_SETTINGS = {
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplay: true,
    autoplaySpeed: 2500,
    speed: 700,
    adaptiveHeight: true,
    pauseOnHover: true,
    pauseOnFocus: true,
    responsive: [
        { breakpoint: 991, settings: { slidesToShow: 2, slidesToScroll: 2 } },
        { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 2 } },
        { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    ],
};
